import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';
import { IconPhone } from '../components/Icons';

const nf = (n) => (n == null ? '—' : Number(n).toLocaleString('it-IT'));

function Card({ title, children, style }) {
  return (
    <div style={{ background: 'var(--surface)', border: '1px solid var(--line)', borderRadius: 14, padding: 18, ...style }}>
      <h2 style={{ margin: '0 0 12px', fontSize: 15 }}>{title}</h2>
      {children}
    </div>
  );
}
function Bar({ label, value, total, color }) {
  const pct = total ? Math.round((value / total) * 100) : 0;
  return (
    <div style={{ marginBottom: 9 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 3 }}>
        <span style={{ fontWeight: 600 }}>{label}</span><span style={{ color: 'var(--muted)' }}>{nf(value)} · {pct}%</span>
      </div>
      <div style={{ height: 9, background: 'var(--surface-2)', borderRadius: 6, overflow: 'hidden' }}>
        <div style={{ width: `${pct}%`, height: '100%', background: color, transition: 'width .4s' }} />
      </div>
    </div>
  );
}

export default function AgenteA456Page() {
  const [ag, setAg] = useState(null);
  const [stats, setStats] = useState(null);
  const [vstats, setVstats] = useState(null);
  const [lead, setLead] = useState(0);
  const load = useCallback(() => {
    axios.get(`${API}/agent/status`).then((r) => setAg(r.data)).catch(() => {});
    axios.get(`${API}/stats`).then((r) => setStats(r.data)).catch(() => {});
    axios.get(`${API}/verify-stats`).then((r) => setVstats(r.data)).catch(() => {});
    axios.get(`${API}/numeri?lead=true&limit=1`).then((r) => setLead(r.data?.total ?? 0)).catch(() => {});
  }, []);
  useEffect(() => { load(); const t = setInterval(load, 8000); return () => clearInterval(t); }, [load]);

  const attivo = !!ag?.attivo;
  const job = ag?.job;
  const standby = job?.status === 'standby';
  const verif = stats?.verificati || 0, tim = stats?.tim || 0, nonTim = stats?.non_tim || 0;
  const err = Math.max(0, verif - tim - nonTim);

  return (
    <div style={{ padding: 20, maxWidth: 900, margin: '0 auto' }}>
      <h1 style={{ fontSize: 20, margin: '0 0 4px', display: 'flex', alignItems: 'center', gap: 10 }}>
        <IconPhone size={20} /> AI 456
      </h1>
      <p style={{ margin: '0 0 18px', color: 'var(--muted)', fontSize: 13 }}>
        Verifica TIM / NON TIM dei numeri fissi tramite il servizio 456.
      </p>

      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 16 }}>
        <Card title="Stato agente" style={{ flex: 1, minWidth: 280 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14 }}>
            <span style={{ width: 10, height: 10, borderRadius: '50%', background: standby ? 'var(--warn)' : attivo ? 'var(--ok)' : 'var(--line)' }} />
            <b>{standby ? 'In standby (disservizio)' : attivo ? 'In chiamata' : 'Fermo'}</b>
            {attivo && <span style={{ color: 'var(--muted)' }}>~{nf(ag?.velocita_min)}/min{job ? ` · ${nf(job.completed)}/${nf(job.total)}` : ''}</span>}
          </div>
          <div style={{ marginTop: 12, fontSize: 12, color: 'var(--muted)' }}>
            Da fare (coda): <b>{nf(ag?.pending)}</b>{ag?.pending === 0 ? ' — nessun numero da verificare' : ''}
          </div>
        </Card>
        <Card title="Riepilogo" style={{ flex: 1, minWidth: 280 }}>
          <div style={{ display: 'flex', gap: 22, flexWrap: 'wrap' }}>
            <div><div style={{ fontSize: 22, fontWeight: 800 }}>{nf(verif)}</div><div style={{ fontSize: 11, color: 'var(--muted)' }}>Verificati</div></div>
            <div><div style={{ fontSize: 22, fontWeight: 800, color: 'var(--err)' }}>{nf(tim)}</div><div style={{ fontSize: 11, color: 'var(--muted)' }}>TIM</div></div>
            <div><div style={{ fontSize: 22, fontWeight: 800, color: 'var(--ok)' }}>{nf(nonTim)}</div><div style={{ fontSize: 11, color: 'var(--muted)' }}>NON TIM</div></div>
            <div><div style={{ fontSize: 22, fontWeight: 800, color: 'var(--info)' }}>{nf(lead)}</div><div style={{ fontSize: 11, color: 'var(--muted)' }}>Lead fibra</div></div>
          </div>
        </Card>
      </div>

      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 16 }}>
        <Card title="Ripartizione esiti" style={{ flex: 1, minWidth: 320 }}>
          {verif === 0 ? (
            <div style={{ color: 'var(--faint)', fontSize: 13 }}>Nessun numero ancora verificato.</div>
          ) : (
            <>
              <Bar label="NON TIM" value={nonTim} total={verif} color="#16a34a" />
              <Bar label="TIM" value={tim} total={verif} color="#e11d48" />
              <Bar label="Errori" value={err} total={verif} color="#f59e0b" />
            </>
          )}
        </Card>
        <Card title="Attività" style={{ flex: 1, minWidth: 320 }}>
          <div style={{ display: 'flex', gap: 22, flexWrap: 'wrap' }}>
            <div><div style={{ fontSize: 22, fontWeight: 800 }}>{nf(vstats?.verifiche_24h)}</div><div style={{ fontSize: 11, color: 'var(--muted)' }}>Verifiche 24h</div></div>
            <div><div style={{ fontSize: 22, fontWeight: 800 }}>{attivo ? nf(ag?.velocita_min) : '—'}</div><div style={{ fontSize: 11, color: 'var(--muted)' }}>al minuto</div></div>
            <div><div style={{ fontSize: 22, fontWeight: 800, color: 'var(--warn)' }}>{nf(ag?.pending)}</div><div style={{ fontSize: 11, color: 'var(--muted)' }}>Da fare</div></div>
          </div>
          {ag?.per_line?.length > 0 && (
            <div style={{ marginTop: 14, borderTop: '1px solid var(--line)', paddingTop: 10 }}>
              <div style={{ fontSize: 11.5, fontWeight: 700, color: 'var(--muted)', marginBottom: 6 }}>Velocità media per linea</div>
              {ag.per_line.map((l) => (
                <div key={l.server} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12.5, padding: '3px 0' }}>
                  <span>{l.nome}</span>
                  <span><b>{l.velocita_media_min != null ? nf(l.velocita_media_min) : '—'}</b>/min · {nf(l.completati)} fatti</span>
                </div>
              ))}
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12.5, padding: '6px 0 0', borderTop: '1px solid var(--surface-2)', marginTop: 4, fontWeight: 700 }}>
                <span>Totale</span>
                <span>{ag.velocita_media_min != null ? nf(ag.velocita_media_min) : '—'}/min · {nf(ag.per_line.reduce((s, l) => s + (l.completati || 0), 0))} fatti</span>
              </div>
            </div>
          )}
          {vstats?.velocita_storica && (
            <div style={{ marginTop: 14, borderTop: '1px solid var(--line)', paddingTop: 10 }}>
              <div style={{ fontSize: 11.5, fontWeight: 700, color: 'var(--muted)', marginBottom: 6 }}>Velocità (storico)</div>
              {[['24h', 'h24'], ['7 giorni', 'g7'], ['Sempre', 'sempre']].map(([label, key]) => {
                const s = vstats.velocita_storica[key] || {};
                return (
                  <div key={key} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12.5, padding: '3px 0' }}>
                    <span>{label}</span>
                    <span><b>{s.vel_min != null ? nf(s.vel_min) : '—'}</b>/min · {nf(s.verifiche || 0)} verifiche</span>
                  </div>
                );
              })}
            </div>
          )}
        </Card>
      </div>
    </div>
  );
}
